export default "__VITE_ASSET__fd4aa755__"